export const instalacionHeroImage =
  "https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20installing%20white%20mini%20split%20air%20conditioner%20on%20modern%20interior%20wall%2C%20construction%20tools%20nearby%2C%20clean%20white%20wall%20background%2C%20professional%20installation%20service%2C%20warm%20ambient%20lighting%2C%20industrial%20photography%20style%2C%20earth%20tones%20with%20blue%20accent%20uniform&width=1200&height=600&seq=instalacion-hero-1&orientation=landscape";

export const installTypes = [
  {
    name: "Minisplit",
    tagline: "Ideal para hogares y oficinas",
    icon: "ri-home-line",
  },
  {
    name: "Piso Techo",
    tagline: "Perfecto para espacios amplios",
    icon: "ri-building-2-line",
  },
  {
    name: "Cassette",
    tagline: "Climatización uniforme para comercios",
    icon: "ri-layout-grid-line",
  },
  {
    name: "Split Ducto",
    tagline: "Potente y eficiente para grandes áreas",
    icon: "ri-stack-line",
  },
  {
    name: "Paquetes Condensados por Agua",
    tagline: "Solución para edificios y empresas",
    icon: "ri-building-4-line",
  },
] as const;

export const installGalleryImages = [
  {
    src: "https://readdy.ai/api/search-image?query=Industrial%20rooftop%20HVAC%20outdoor%20unit%20installation%20on%20commercial%20building%20flat%20roof%2C%20white%20metal%20air%20conditioning%20equipment%2C%20professional%20installation%20photography%2C%20clear%20blue%20sky%2C%20industrial%20setting%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-1&orientation=landscape",
    alt: "Instalación rooftop industrial",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20installing%20outdoor%20condenser%20unit%20on%20building%20exterior%20wall%2C%20white%20multi-split%20system%2C%20wiring%20and%20piping%20visible%2C%20industrial%20installation%20photography%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-2&orientation=landscape",
    alt: "Instalación unidad exterior multi-split",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Industrial%20air%20ducting%20installation%20in%20commercial%20building%2C%20galvanized%20metal%20ducts%20and%20piping%20suspended%20from%20ceiling%2C%20HVAC%20system%20installation%20photography%2C%20industrial%20warehouse%20setting%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-3&orientation=landscape",
    alt: "Ductería industrial",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Commercial%20wall%20mounted%20split%20air%20conditioner%20outdoor%20units%20in%20a%20row%20on%20building%20exterior%2C%20white%20metal%20condensers%20with%20fans%2C%20HVAC%20installation%20photography%2C%20urban%20industrial%20setting%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-4&orientation=landscape",
    alt: "Unidades exteriores instaladas",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Professional%20air%20conditioning%20outdoor%20condenser%20units%20on%20commercial%20rooftop%20installation%2C%20multiple%20white%20VRF%20units%20arranged%20in%20line%2C%20piping%20and%20electrical%20connections%2C%20industrial%20photography%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-5&orientation=landscape",
    alt: "Instalación rooftop VRF",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Modern%20ceiling%20cassette%20air%20conditioning%20unit%20installation%20in%20commercial%20office%20space%2C%20square%20panel%20mounted%20in%20drop%20ceiling%2C%20clean%20modern%20interior%2C%20professional%20HVAC%20installation%20photography%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-6&orientation=landscape",
    alt: "Instalación cassette techo",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Industrial%20insulated%20HVAC%20refrigerant%20piping%20system%20installation%20on%20building%20exterior%2C%20black%20insulated%20copper%20pipes%20running%20along%20wall%2C%20professional%20installation%20photography%2C%20industrial%20construction%20site%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-7&orientation=landscape",
    alt: "Tuberías refrigerante instaladas",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Large%20industrial%20HVAC%20rooftop%20unit%20being%20installed%20with%20crane%2C%20orange%20construction%20crane%20lifting%20packaged%20air%20conditioning%20unit%20onto%20building%20roof%2C%20professional%20industrial%20photography%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-8&orientation=landscape",
    alt: "Instalación con grúa",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Commercial%20building%20exterior%20with%20multiple%20air%20conditioning%20outdoor%20units%20mounted%20on%20metal%20cage%20platform%2C%20white%20condenser%20units%20arranged%20vertically%2C%20HVAC%20installation%20photography%2C%20modern%20building%20facade%2C%20earth%20tones&width=400&height=300&seq=instalacion-gallery-9&orientation=landscape",
    alt: "Unidades en jaula metálica",
  },
] as const;

export const installWhyChoose = [
  {
    title: "Experiencia y especialización en climatización y refrigeración",
    icon: "ri-award-line",
  },
  {
    title: "Cobertura nacional, brindando servicio en toda Colombia",
    icon: "ri-map-pin-line",
  },
  {
    title: "Soporte técnico garantizado con mantenimiento y repuestos originales",
    icon: "ri-shield-check-line",
  },
  {
    title: "Diseños personalizados para cada proyecto, asegurando la máxima eficiencia",
    icon: "ri-pencil-ruler-line",
  },
  {
    title: "Compromiso con el ahorro energético, aplicando tecnología Inverter y sistemas inteligentes",
    icon: "ri-flashlight-line",
  },
  {
    title: "Aliados con marcas reconocidas, asegurando equipos de alta calidad y durabilidad",
    icon: "ri-verified-badge-line",
  },
] as const;